import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../redux-sagas/actions/actionCreators';
import * as leagueActions from '../redux-sagas/actions/leagueActions';
import * as seasonActions from '../redux-sagas/actions/seasonActions';
import * as familyActions from '../redux-sagas/actions/familyActions';
import * as pouchActions from '../redux-sagas/actions/pouchActions';
import * as divisionsActions from '../redux-sagas/actions/divisionsActions';
import * as cartActions from '../redux-sagas/actions/cartActions';
import * as paymentsActions from '../redux-sagas/actions/paymentsActions';
import Main from '../components/Main.Family';
import _ from 'lodash';

function mapStateToProps(state) {
    return {
        loggedIn: state.loggedIn,
        auth: state.auth,
        autoPaySettings: state.autoPaySettings,
        title: state.title,
        leagues: state.leagues,
        seasons: state.seasons,
        league: state.league,
        divisions: state.divisions,
        fetchingData: state.fetchingData,
        teams: state.teams,
        archived_teams: state.archived_teams,
        family: state.family,
        pouch: state.pouch,
        cart: state.cart,
        questions: state.questions,
        paymentPlans: state.paymentPlans,
        familyRegistration: state.familyRegistration,
        teamRegistration: state.teamRegistration,
        isCartOpen: state.isCartOpen,
        disclaimer: state.disclaimer,
        payments: state.payments,
        balance: state.balance,
        dues: state.dues,
        selectedTeam: state.selectedTeam,
        selectedUser: state.selectedUser,
        pastDues: state.pastDues
    }
}

function mapDispatchToProps(dispatch) {
    return _.extend({
        leagueActions: bindActionCreators(leagueActions, dispatch),
        seasonActions: bindActionCreators(seasonActions, dispatch),
        familyActions: bindActionCreators(familyActions, dispatch),
        pouchActions: bindActionCreators(pouchActions, dispatch),
        divisionsActions: bindActionCreators(divisionsActions, dispatch),
        cartActions: bindActionCreators(cartActions, dispatch),
        paymentsActions: bindActionCreators(paymentsActions, dispatch)
    }, bindActionCreators(actionCreators, dispatch))
}

const App_Payments = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App_Payments;
